/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state-management/root-reducer";
import { setIsPackageSelectorModalOpen } from "../../../../state-management/slices/packageSelector/package-selector.slice";
import { useAppDispatch } from "../../../../state-management/store";
import PACKAGE_ITEM from "../renderer/PackageItem.renderer";
import PackageSelectorPopOutStyles from "./PackageSelectorPopOut.styles";
import { IPackageSelectorPopOutProps } from "./PackageSelectorPopOut.types";

const PACKAGE_SELECTOR_POPOUT: React.FC<IPackageSelectorPopOutProps> = (
  props: IPackageSelectorPopOutProps
) => {
  const dispatch = useAppDispatch();

  // APP STATE
  const { selectedPackage } = useSelector(
    (state: RootState) => state.packageSelector
  );

  return (
    <PackageSelectorPopOutStyles.PackageSelectorPopOut
      className="package-selector-popout"
      data-testid="package-selector-popout"
    >
      <PACKAGE_ITEM
        packageItem={selectedPackage}
        isPopOutItem={true}
        selected={false}
        onClick={
          /* istanbul ignore next */ () => {
            dispatch(setIsPackageSelectorModalOpen(true));
          }
        }
      />
    </PackageSelectorPopOutStyles.PackageSelectorPopOut>
  );
};

export default PACKAGE_SELECTOR_POPOUT;
